import React from 'react';
import './SubmissionTypeSelector.css';

const ALL_TYPE_OPTIONS = [
  { value: 'short', label: 'Short Video' },
  { value: 'full', label: 'Full Video' },
  { value: 'audio', label: 'Audio-based' }
];

const SubmissionTypeSelector = ({ value, onChange, error, disabled, allowedTypes }) => {
  // Filter options to only show allowed types
  const availableOptions = allowedTypes && allowedTypes.length > 0
    ? ALL_TYPE_OPTIONS.filter((option) => allowedTypes.includes(option.value))
    : ALL_TYPE_OPTIONS;

  // Auto-select single option and disable
  const isSingleOption = availableOptions.length === 1;
  const selectedValue = isSingleOption ? availableOptions[0].value : value;
  const isDisabled = disabled || availableOptions.length === 0 || isSingleOption;

  // Notify parent of auto-selection
  React.useEffect(() => {
    if (isSingleOption && value !== selectedValue) {
      onChange(selectedValue);
    }
  }, [isSingleOption, selectedValue, value, onChange]);

  return (
    <div className="submission-type-selector">
      <label htmlFor="submissionType">Submission Type *</label>
      <select
        id="submissionType"
        value={selectedValue}
        onChange={(event) => onChange(event.target.value)}
        disabled={isDisabled}
        className={error ? 'field-error' : ''}
      >
        <option value="">Select submission type</option>
        {availableOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && <small className="field-error-text">{error}</small>}
      {isSingleOption && (
        <small className="field-info-text">This is the only accepted submission type for this competition</small>
      )}
      {availableOptions.length === 0 && (
        <small className="field-error-text">No submission types available for this competition</small>
      )}
    </div>
  );
};

export default SubmissionTypeSelector;
